// 应用根（EP-004 / EP-005-S3）—— 挂载启动加载屏或主视图，启动 store 与状态机轮询。
import { useEffect, useState } from 'react';
import { useGameStore } from './store';
import { startStateMachine } from './core/stateMachine';
import { MainView } from './views/MainView';
import { BootScreen } from './views/BootScreen';
import { getMusicEnabled, setMusicEnabled, bindFirstGestureToPlay } from './audio/music';

export function App() {
  const [entered, setEntered] = useState(false);

  useEffect(() => {
    useGameStore.getState().init();
    bindFirstGestureToPlay(); // 首个真手势内按偏好启动音乐（刷新后自动播放策略要求）
    const stop = startStateMachine();
    return stop;
  }, []);

  // 注：BootScreen 的「进度满自动进入」是 rAF 回调，**不是**真实用户手势，
  // 其中 setMusicEnabled 的 play() 会被自动播放策略拦截（错误被静默吞掉）。
  // 可靠的启动点是 bindFirstGestureToPlay：用户首次点击/触摸/按键时按偏好播放。
  const handleEnter = () => {
    if (getMusicEnabled()) setMusicEnabled(true);
    setEntered(true);
  };

  if (!entered) return <BootScreen onEnter={handleEnter} />;
  return <MainView />;
}
